import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import axios, { AxiosError } from "axios";
import StateModel from "../../models/masters/state-model";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/State/GetAllState";// //{/api/State/GetAllState}`)  //// "https://localhost:7054/api/State/GetAllState";
export const useGetStates = createQuery<
  StateModel[],
  null,
  AxiosError
>({
  queryKey: ["keyStatelist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});